const getInteger = (str: string | number) => {
  if (typeof str === 'string') {
    return parseInt(str.replaceAll(' ', ''), 10);
  }
  return str;
};

export default getInteger;
